import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../components/TranslationText';
import ActionButton from '../components/ActionButton';
import { useSelector } from 'react-redux';
import axios from "../axios/axiosUmbraco";
import Loader from '../components/Loader';
import SectionTitle from '../components/SectionTitle';
import PillBtn from '../components/PillBtn';
import SupplierCard from '../components/SupplierCard';

const BaseURL = process.env.REACT_APP_BASE_URL;
const id = process.env.REACT_APP_HORSE_SUPPLIES_PAGE_CONTENT_ID;
const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function HorseSupplies() {
    const { translate } = useTranslate();

    const { currentLanguage } = useSelector(
        (state) => state.studBookSlice
    );



    const [labelObj, setLabelObj] = useState(null);
    const [suppliers, setSuppliers] = useState([]);



    function getCurrentLanguageUmbraco() {
        // Replace this with your logic to retrieve the current language
        // For example, you can retrieve it from localStorage or from a state variable
        const lang = localStorage.getItem("eahsLang") ?? "en";
        if (lang == "en") return 'en-US';
        else return 'ar-AE'; // Defaulting to English for demonstration
    }

    async function getdata() {
        const umbraco = await axios.get(`/umbraco/delivery/api/v1/content/item/${id}`, {
            headers: {
                "accept-language": getCurrentLanguageUmbraco(),

            }
        })
        const formattedData =
        {
            labelTitle: umbraco.data.properties.listTitle,
            labelDescription: umbraco.data.properties.listDescription
        }
        setLabelObj(formattedData);
    }

    async function getsuppliers() {
        const umbraco = await axios.get(`/umbraco/delivery/api/v1/content?fetch=descendants:${id}&skip=0&take=10`, {
            headers: {
                "accept-language": getCurrentLanguageUmbraco(),

            }
        })
        const formattedData = umbraco.data?.items.map((item) => ({
            itemID: item?.id ?? '',
            itemCover: item.properties?.itemCover ? item.properties?.itemCover[0]?.url : '',
            itemShortDescription: item?.properties?.itemShortDescription ?? '',
            itemTitle: item?.properties?.itemTitle ?? "",
            itemWebsite: item?.properties?.itemWebsite ?? "",
            itemPhone: item?.properties?.itemPhone ?? "",
            itemPdfText: item?.properties?.itemPdfText ?? "",
            itemPdfUrl: item?.properties?.itemPdf ?? "",
            itemEmail: item?.properties?.itemEmail ?? "",
        }));
        setSuppliers(formattedData);

    }

    useEffect(() => {
        getsuppliers()
        getdata();

    }, [currentLanguage])
    const langauge = localStorage.getItem('eahsLang') ?? 'en';


    return (
        <>
            {!!labelObj ?
                <>
                    <div className='row mb-1 rtl'>
                        <SectionTitle noMargin={true} section_name={labelObj?.labelTitle} />
                        <p className='supplierdesc'>
                            {labelObj.labelDescription}
                        </p>
                    </div>
                    <div className='row  rtl'>
                        {suppliers.length > 0 &&
                            suppliers.map((item) => (
                                <SupplierCard item={item} baseLink={'horseSupplies'} />
                            ))}
                    </div>
                </> : <Loader />
            }

        </>
    )
}
